import {ContextProvider} from "../contexts/ContextProvider";


export default function prependContexts(WrappedComponent) {
    return function (props) {
        return (
            <ContextProvider>
                    <WrappedComponent {...props} />
            </ContextProvider>
        );
    };
}
